import React, { useState, useEffect } from 'react';
import { postData } from "../../../../../ApiServices/ApiService";
import { ORG_CONFIGURATION, ORG_INVOICE, ORG_INVOICE_PAYMENT_CONFIGURATION } from "../../../../../ApiServices/BaseURL";
import { useTheme } from '../../../../../GlobalContext/GlobalContext';
import { logFrontendException } from '../../../../../Utils/Exception';

const InvoiceSettingsController = () => {
    const { setIsLoginPopup } = useTheme();
    const [estimateSeries, setEstimateSeries] = useState([]);
    const [invoiceSeries, setInvoiceSeries] = useState([]);
    const [receiptSeries, setReceiptSeries] = useState([]);

    const [taxSgst, setTaxSgst] = useState(0);
    const [taxCgst, setTaxCgst] = useState(0);
    const [taxIgst, setTaxIgst] = useState(0);
    const [taxConvFee, setTaxConvFee] = useState(0);
    const [bookOpenBalance, setBookOpenBalance] = useState(0);
    const [narration, setNarration] = useState("");
    const [notes, setNotes] = useState("");
    const [overdueDays, setOverdueDays] = useState(0);

    const [loadingEstimate, setLoadingEstimate] = useState(false);
    const [loadingInvoice, setLoadingInvoice] = useState(false);
    const [loadingReceipt, setLoadingReceipt] = useState(false);
    const [loadingSettings, setLoadingSettings] = useState(false);

    const [errorEstimate, setErrorEstimate] = useState("");
    const [errorInvoice, setErrorInvoice] = useState("");
    const [errorReceipt, setErrorReceipt] = useState("");
    const [errorSettings, setErrorSettings] = useState("");

    const [showServiceEstimateSeries, setShowServiceEstimateSeries] = useState(true);
    const [showInvoiceSeries, setShowInvoiceSeries] = useState(false);
    const [showReceiptSeries, setShowReceiptSeries] = useState(false);

    const [editServiceEstimateSeries, setEditServiceEstimateSeries] = useState(false);
    const [editInvoiceSeries, setEditInvoiceSeries] = useState(false);
    const [editReceiptSeries, setEditReceiptSeries] = useState(false);

    const [selectedServiceEstimate, setSelectedServiceEstimate] = useState(null);
    const [selectedInvoiceSeries, setSelectedInvoiceSeries] = useState(null);
    const [selectedReceiptSeries, setSelectedReceiptSeries] = useState(null);

    const [paymentData, setPaymentData] = useState(null);
    const [paymentError, setPayementError] = useState('');
    const [paymentLoading, setPaymentLoading] = useState(false);

    const pageName = "InvoiceSettingsController";
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

    useEffect(() => {
        fetchEstimateSeriesHistory();
        fetchInvoiceSeriesHistory();
        fetchReceiptSeriesHistory();
        fetchInvoiceSettings();
        fetchPaymentConfig();
    }, []);

    const toggleServiceEstimateSeries = () => {
        setShowServiceEstimateSeries(true);
        setShowInvoiceSeries(false);
        setShowReceiptSeries(false);
        setEditServiceEstimateSeries(false);
        setEditInvoiceSeries(false);
        setEditReceiptSeries(false);
    };

    const toggleInvoiceSeries = () => {
        setShowInvoiceSeries(true);
        setShowServiceEstimateSeries(false);
        setShowReceiptSeries(false);
        setEditServiceEstimateSeries(false);
        setEditInvoiceSeries(false);
        setEditReceiptSeries(false);
    };

    const toggleReceiptSeries = () => {
        setShowReceiptSeries(true);
        setShowServiceEstimateSeries(false);
        setShowInvoiceSeries(false);
        setEditServiceEstimateSeries(false);
        setEditInvoiceSeries(false);
        setEditReceiptSeries(false);
    };

    const toggleUpdateServiceEstimateSeries = (item) => {
        setSelectedServiceEstimate(item);
        setEditServiceEstimateSeries(true);
        setEditInvoiceSeries(false);
        setEditReceiptSeries(false);
        setShowServiceEstimateSeries(false);
        setShowInvoiceSeries(false);
        setShowReceiptSeries(false);
        setSelectedInvoiceSeries(null);
        setSelectedReceiptSeries(null);
    };

    const toggleUpdateInvoiceSeries = (item) => {
        setSelectedInvoiceSeries(item);
        setEditInvoiceSeries(true);
        setEditServiceEstimateSeries(false);
        setEditReceiptSeries(false);
        setShowServiceEstimateSeries(false);
        setShowInvoiceSeries(false);
        setShowReceiptSeries(false);
        setSelectedServiceEstimate(null);
        setSelectedReceiptSeries(null);
    };

    const toggleUpdateReceiptSeries = (item) => {
        setSelectedReceiptSeries(item);
        setEditReceiptSeries(true);
        setEditServiceEstimateSeries(false);
        setEditInvoiceSeries(false);
        setShowServiceEstimateSeries(false);
        setShowInvoiceSeries(false);
        setShowReceiptSeries(false);
        setSelectedServiceEstimate(null);
        setSelectedInvoiceSeries(null);
    };

    const fetchSeriesHistory = async (actionType, setSeries, setLoading, setError) => {
        try {
            setSeries([]);
            setError('');
            setLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            const payLoad = {
                "action": actionType,
                "emp_id_auth": storedUserInfo?.emp_id,
            };

            //console.log('handleSearchClient header payload', payLoad);
            const response = await postData(ORG_CONFIGURATION, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setSeries(responseData?.dataJ);
                    } else {
                        setError(responseData?.info || 'Failed to fetch Client. Please try again.');
                        logFrontendException(storedUserId, pageName, "fetchSeriesHistory", responseData?.info || '');
                    }
                } else {
                    setError(responseData?.info || 'Failed to fetch Client.');
                    logFrontendException(storedUserId, pageName, "fetchSeriesHistory", responseData?.info || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "fetchSeriesHistory", response || '');
                } else {
                    setError(responseData?.info || 'Bad request. Please check the request parameters.');
                    logFrontendException(storedUserId, pageName, "fetchSeriesHistory", response || '');
                }
                setIsLoginPopup(true)
            } else {
                setError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "fetchSeriesHistory", response || '');
            }
        } catch (error) {
            setError(`Failed to fetch client. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, "fetchSeriesHistory-catch", error || '');
        } finally {
            setLoading(false);
        }
    };

    const fetchEstimateSeriesHistory = () => fetchSeriesHistory("ESTIMATE_SERIES_LIST", setEstimateSeries, setLoadingEstimate, setErrorEstimate);
    const fetchInvoiceSeriesHistory = () => fetchSeriesHistory("INVOICE_SERIES_LIST", setInvoiceSeries, setLoadingInvoice, setErrorInvoice);
    const fetchReceiptSeriesHistory = () => fetchSeriesHistory("RECEIPT_SERIES_LIST", setReceiptSeries, setLoadingReceipt, setErrorReceipt);

    const fetchInvoiceSettings = async () => {
        try {
            setErrorSettings('');
            setLoadingSettings(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            const payLoad = {
                "action": "INVOICE_SETTINGS_GET",
                "emp_id_auth": storedUserInfo?.emp_id,
            };

            //console.log('handleSearchClient header payload', payLoad);
            const response = await postData(ORG_INVOICE, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        const data = responseData.dataJ[0];

                        setTaxSgst(data?.acc_tax_sgst);
                        setTaxCgst(data?.acc_tax_cgst);
                        setTaxIgst(data?.acc_tax_igst);
                        setTaxConvFee(data?.acc_tax_conv_fee);
                        setBookOpenBalance(data?.acc_book_open_balance || 0);
                        setNarration(data?.acc_narration || "");
                        setNotes(data?.acc_notes || "");
                        setOverdueDays(data?.acc_overdue_days || 0);
                    } else {
                        setErrorSettings(responseData?.info || 'Failed to fetch Client. Please try again.');
                        logFrontendException(storedUserId, pageName, "fetchInvoiceSettings", responseData?.info || '');
                    }
                } else {
                    setErrorSettings(responseData?.info || 'Failed to fetch Client.');
                    logFrontendException(storedUserId, pageName, "fetchInvoiceSettings", responseData?.info || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setErrorSettings('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "fetchInvoiceSettings", response || '');
                } else {
                    setErrorSettings(responseData?.info || 'Bad request. Please check the request parameters.');
                    logFrontendException(storedUserId, pageName, "fetchInvoiceSettings", response || '');
                }
                setIsLoginPopup(true)
            } else {
                setErrorSettings('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "fetchInvoiceSettings", response || '');
            }
        } catch (error) {
            setErrorSettings(`Failed to fetch client. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, "fetchInvoiceSettings-catch", error || '');
        } finally {
            setLoadingSettings(false);
        }
    };

    const invoiceRefresh = () => {
        fetchInvoiceSettings();
    }

    const fetchPaymentConfig = async () => {
        setPaymentLoading(true);
        setPayementError('');
        setPaymentData(null);

        const storedUser = JSON.parse(localStorage.getItem("_userInfo_"));

        try {
            const payload = {
                action_type: 'get_payment_config',
                emp_id_auth: storedUser?.emp_id,
            };

            const response = await postData(ORG_INVOICE_PAYMENT_CONFIGURATION, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.status_code === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        if (responseData?.dataJ && Object.keys(responseData.dataJ).length > 0) {
                            setPaymentData(responseData?.dataJ);
                        } else {
                            setPayementError(responseData?.info || "No Configuration is available.");
                            logFrontendException(storedUser?.emp_id, pageName, 'fetchPaymentConfig', responseData?.info);
                        }
                    } else {
                        setPayementError(responseData?.info || "Failed to fetch configuration.");
                        logFrontendException(storedUser?.emp_id, pageName, 'fetchPaymentConfig', responseData?.info);
                    }
                } else {
                    setPayementError(responseData?.info || "Unable to fetch configuration.Please try again later.");
                    logFrontendException(storedUser?.emp_id, pageName, 'fetchPaymentConfig', responseData);
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setPayementError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true)
                logFrontendException(storedUser?.emp_id, pageName, 'fetchPaymentConfig', response || '');
            } else {
                setPayementError("Failed to fetch configuration.Please try again.");
                logFrontendException(storedUser?.emp_id, pageName, 'fetchPaymentConfig', response || '');
            }
        } catch (err) {
            setPayementError("Unable to fetch configuration.Please check your internet connection and try again.");
            logFrontendException(storedUser?.emp_id, pageName, 'fetchPaymentConfig', err);
        } finally {
            setPaymentLoading(false);
        }
    };

    return {
        estimateSeries, loadingEstimate, errorEstimate,
        invoiceSeries, loadingInvoice, errorInvoice,
        receiptSeries, loadingReceipt, errorReceipt,
        taxSgst, taxCgst, taxIgst, taxConvFee, bookOpenBalance, narration, notes, overdueDays,
        loadingSettings, errorSettings,
        invoiceRefresh,
        fetchEstimateSeriesHistory, fetchInvoiceSeriesHistory, fetchReceiptSeriesHistory,
        showServiceEstimateSeries, showInvoiceSeries, showReceiptSeries,
        editServiceEstimateSeries, editInvoiceSeries, editReceiptSeries,
        selectedServiceEstimate, selectedInvoiceSeries, selectedReceiptSeries,
        toggleServiceEstimateSeries, toggleInvoiceSeries, toggleReceiptSeries,
        toggleUpdateServiceEstimateSeries, toggleUpdateInvoiceSeries, toggleUpdateReceiptSeries,
        paymentData,paymentError,paymentLoading,fetchPaymentConfig,
    };
};

export default InvoiceSettingsController;
